import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let receivable_id = useDataValue({
    context: 'entry',
    path: 'transaction.receivable.id',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'entry',
    viewPath: props.viewPath,
  })
  return function onClick() {
    submit({ type: 'FOCUS_RECEIVABLE', receivable_id })
  }
}
